// extracted by mini-css-extract-plugin
module.exports = {"regionSelectorBar":"region-selector_regionSelectorBar___OXpG"};